import { Loader2 } from 'lucide-react';

/**
 * Fallback fuer `<Suspense>` um code-gesplittete Seiten (`React.lazy`).
 *
 * Bewusst schlicht und ohne Layout-Abhaengigkeit: sie erscheint fuer den
 * kurzen Moment, in dem der Chunk einer selten benoetigten Seite laedt,
 * und muss dafuer selbst nichts nachladen. Gleicher Stil wie die
 * Ladeanzeige in `ProtectedRoute` (dort fuer die Sitzungspruefung, hier
 * fuer den Seiten-Chunk) -- zwei verschiedene Wartezustaende, eine
 * Optik.
 */
export function SeitenLadeanzeige() {
  return (
    <div className="flex h-full min-h-[50vh] items-center justify-center text-gray-500">
      <Loader2 className="mr-2 h-5 w-5 animate-spin" />
      <span>Seite wird geladen…</span>
    </div>
  );
}

export default SeitenLadeanzeige;
